// To add new custom events, dispatch them with :
//    window.dispatchEvent(new CustomEvent('lgf.myCustomEvent', {'details': {}}))
//
// Then add a config in `events` object :
//    { localEvent: 'lgf.myCustomEvent', eventName: 'customEvent' }
//
// "localEvent": local JS event name
// "eventName": the GTM datalayer event name

const events = [
  { localEvent: 'lgf.contactSubmitted', eventName: 'contact' },
  { localEvent: 'lgf.productViewItemList', eventName: 'view_item_list' },
  { localEvent: 'lgf.productSelectItem', eventName: 'select_item' },
  { localEvent: 'lgf.configurator.init', eventName: 'customize_init' },
  { localEvent: 'lgf.configurator.stepFormat', eventName: 'customize_format' },
  { localEvent: 'lgf.configurator.stepVisual', eventName: 'customize_visual' },
  { localEvent: 'lgf.configurator.stepContent', eventName: 'view_item' },
  {
    localEvent: 'lgf.configurator.customizationUpdate',
    eventName: 'customize_content',
  },
  { localEvent: 'lgf.addToCart', eventName: 'add_to_cart' },
  {
    localEvent: 'lgf.addToCartFromUpsell',
    eventName: 'add_to_cart_from_upsell',
  },
  { localEvent: 'lgf.removeFromCart', eventName: 'remove_from_cart' },
  { localEvent: 'lgf.viewCart', eventName: 'view_cart' },
  { localEvent: 'lgf.beginCheckout', eventName: 'begin_checkout' },
  { localEvent: 'lgf.saveShipping', eventName: 'add_shipping_info' },
  { localEvent: 'lgf.initiateOrderPayment', eventName: 'add_payment_info' },
  { localEvent: 'lgf.orderPlaced', eventName: 'purchase' },
  { localEvent: 'lgf.getQuotation', eventName: 'generate_lead' },
];

class Tracking {
  init() {
    window.dataLayer = window.dataLayer || [];
    this.sendEvent('datalayer_ready', { content_group: 'product' });

    this.registerEvents();

    this.registerListeners();

    this.loadEventStack();
  }

  sendEvent(event, details) {
    details = details || {};

    window.dataLayer.push({
      event: event,
      ...details,
    });
  }

  registerEvents() {
    events.forEach(event => {
      window.addEventListener(event.localEvent, e => {
        this.sendEvent(event.eventName, e.detail);
      });
    });
  }

  loadEventStack() {
    const eventStack = window.trackingEventStack || [];

    eventStack.forEach(event => {
      window.dispatchEvent(
        new CustomEvent(event.localEvent, { detail: event.details })
      );
    });
  }

  registerListeners() {
    this.registerClickListener();
  }

  registerClickListener() {
    document.body.addEventListener('click', e => {
      const element = e.target.matches('[data-tracking-click]')
        ? e.target
        : e.target.closest('[data-tracking-click]');

      if (element) {
        window.dispatchEvent(
          new CustomEvent(element.dataset.trackingEvent, {
            detail: JSON.parse(element.dataset.trackingData),
          })
        );
      }
    });
  }
}

export default new Tracking();
